<template>
  <v-list class="pt-0" dense :key="updateIndex">
    <template v-for="(item, i) in items">
      <v-divider v-if="item.divider" :key="i" :class="item.className"></v-divider>

      <template v-if="item.items && (!item.roles || $auth.hasRole(item.roles))">
        <v-subheader>{{ item.title }}</v-subheader>
        <navigation-item v-for="subItem in item.items" :key="subItem.title" :item="subItem" />
      </template>

      <navigation-item v-if="!item.divider && !item.items" :key="i" :item="item" />
    </template>
  </v-list>
</template>

<script>
import NavigationItem from './NavigationItem'

export default {
  data () {
    let $t = (title) => {
      return this.$t(title)
    }

    return {
      updateIndex: 0,
      items: [
        { divider: true },
        { title: $t('titles.dashboard'), icon: 'dashboard', href: '/', roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN', 'COMPANY_USER'] },
        { title: $t('titles.recordings'), icon: 'view_list', href: '/recordings', roles: ['COMPANY_ADMIN', 'COMPANY_USER'], ignoreDelegations: true },
        {
          title: $t('titles.admin.title'),
          icon: 'work',
          active: false,
          roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'],
          items: [
            { title: $t('titles.admin.users'), icon: 'account_box', href: '/admin/users', roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'] },
            { title: $t('titles.admin.companies'), icon: 'receipt', href: '/admin/companies', roles: ['GROUP_ADMIN'] },
            { title: $t('titles.admin.companyGroups'), icon: 'group', href: '/admin/company-groups', roles: ['SUPER_ADMIN'] },
            { title: $t('titles.admin.companyDelegations'), icon: 'account_box', href: '/admin/company-delegations', roles: ['COMPANY_ADMIN'], ignoreDelegations: true },
            { title: $t('titles.admin.lines'), icon: 'phone', href: '/admin/lines', roles: ['GROUP_ADMIN', 'COMPANY_ADMIN'] },
            { title: $t('titles.admin.lineGroups'), icon: 'phone', href: '/admin/lineGroups', roles: ['COMPANY_ADMIN'] },
            { title: $t('titles.admin.numbers'), icon: 'filter_none', href: '/admin/numbers', roles: ['COMPANY_ADMIN'] },
            { title: $t('titles.admin.tags'), icon: 'label', href: '/admin/tags', roles: ['COMPANY_ADMIN'] },
            { title: $t('titles.admin.configuration'), icon: 'settings_input_component', href: '/admin/configuration', roles: ['COMPANY_ADMIN'] }
          ]
        },
        {
          title: $t('titles.reports.title'),
          roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'],
          items: [
            { title: $t('titles.reports.accesses'), icon: 'view_list', href: '/reports/accesses' },
            { title: $t('titles.reports.dataChanges'), icon: 'view_list', href: '/reports/data-changes' },
            { title: $t('titles.reports.systemStorage'), icon: 'pie_chart', href: '/reports/system-storage', roles: ['SUPER_ADMIN'] },
            { title: $t('titles.reports.logicStorage'), icon: 'pie_chart', href: '/reports/logic-storage', roles: ['GROUP_ADMIN', 'COMPANY_ADMIN'] },
            { title: $t('titles.reports.notifications'), icon: 'info', href: '/reports/notifications', roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'] }
          ]
        },
        { divider: true, className: 'mt-5' },
        { title: $t('titles.profile'), icon: 'account_circle', href: '/profile' },
        { title: $t('titles.logout'), icon: 'exit_to_app', href: '/logout' }
      ]
    }
  },
  methods: {
    refresh () {
      this.updateIndex++
    }
  },
  components: {
    NavigationItem
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Navigation.vue?a1e97458